// Extracts a normalized email address from a raw `from` header value.
// Used by both the API (to key sender→label memory) and the mobile categorizer
// (to short-circuit known senders before NLI). Returning the SAME normalized
// form on both sides is load-bearing — drift would silently break the lookup.
const ANGLE_BRACKETS = /<([^>]+)>/;

export function normalizeSenderAddr(input: string | null | undefined): string | null {
  if (!input) return null;
  const trimmed = input.trim();
  if (!trimmed) return null;
  const inAngles = trimmed.match(ANGLE_BRACKETS)?.[1] ?? trimmed;
  const candidate = inAngles.trim().toLowerCase();
  if (!candidate.includes('@')) return null;
  return candidate;
}

// Minimum confirmCount for the sender→label memory short-circuit to fire.
// Below this, web/mobile categorizers fall through to NLI. Shared across
// clients so a tuning change applies everywhere at once.
export const SENDER_MEMORY_MIN_CONFIRM = 2;
